<template>
  <div id="order-banners">
    <!-- Content -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              Banners - Ordernar
            </h4>
          </CCardHeader>

          <CCardBody>
            <!-- Filter -->
            <CRow>
              <CCol
                lg="3"
                class="mb-2"
              >
                <Multiselect
                  :value="languageOptions.find(option => option.value == query.language)"
                  :options="languageOptions"
                  label="label"
                  track-by="value"
                  placeholder="Idioma"
                  @select="(selected) => query.language = selected.value"
                />
              </CCol>
            </CRow>
            <!-- Sortable -->
            <CRow>
              <CCol col="12">
                <Sortable
                  :items="datatable.items"
                  :fields="datatable.fields"
                  :enable-switch-status="false"
                  :enable-export="false"
                  has-thumb
                  @endDragging="endDragging"
                >
                </Sortable>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Sortable from '@/components/ui/Sortable'
import { orderBy, debounce } from 'lodash'
import BannerService from '@/services/banner.service'
import Multiselect from '@/components/ui/Multiselect'

export default {
  metaInfo: {
    title: 'Banners',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_banners')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Sortable,
    Multiselect
  },

  data() {
    return {
      datatable: {
        items: [],
        fields: [
          {
            key: 'status',
            label: 'Status',
            sorter: false,
            _style: 'width: 8%; min-width: 100px;'
          },
          {
            key: 'heading',
            label: 'Banner',
            sorter: false,
            _style: 'width: 60%;',
            thumb: true
          },
          {
            key: 'language',
            label: 'Idioma',
            sorter: false
          }
        ]
      },
      languageOptions: [
        {
          label: 'Português',
          value: 1
        },
        {
          label: 'Inglês',
          value: 2
        },
        {
          label: 'Espanhol',
          value: 3
        }
      ],
      query: {
        search: '',
        page: 1,
        perpage: localStorage.getItem('perPageItem')
          ? parseFloat(localStorage.getItem('perPageItem'))
          : 10,
        pagination: false,
        status: true,
        language: 1,
        sorter: {
          asc: false,
          column: ''
        }
      },
      processing: false
    }
  },

  watch: {
    query: {
      handler: 'updateDataTable',
      deep: true
    }
  },

  async created() {
    await this.updateDataTable()
  },

  methods: {
    async updateDataTable() {
      const response = await BannerService.getAll(this.query)

      if (response.data) {
        const newItems = response.data.map((item) => {
          return {
            ...item,
            thumb: item.medias.length > 0 ? item.medias[0].url : null,
            status: item.status === 1
          }
        })

        this.datatable.items = orderBy(newItems, ['order'])
      }
    },

    endDragging: debounce(function(items) {
      this.datatable.items = items
      BannerService.updateBannerOrders(this.datatable.items)

      this.$notify({
        group: 'notifications',
        type: 'success',
        text: 'Ordenação alterada com sucesso.'
      })
    }, 1000)
  }
}
</script>

<style lang="scss">
#order-banners {
  .orderButton {
    margin-right: 10px;
  }

  .thumb {
    width: 80px !important;
  }
}
</style>
